import { render } from "./CuratorGallery.vue?vue&type=template&id=81ec7e9e"
import script from "./CuratorGallery.vue?vue&type=script&lang=js"
export * from "./CuratorGallery.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__